<template>
  <div id="app">
    <header
      id="renew2_header"
      v-if="
        $route.name != 'yagiprimeSAdlpRirekisho' &&
        $route.name != 'okinaviPage' &&
        $route.name != 'shogaiPage' &&
        !$route.path.startsWith('/yagifriends') &&
        $site.appFlag != 'b' &&
        !isOnlyPreview
      "
    >
      <div class="menu_block renew2_wrapper">
        <!--ヘッダーロゴ左-->
        <div class="header-left">
          <h1
            v-if="$globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel"
            id="yagiprime_member"
            class="h1"
          >
            <router-link :to="{ path: '/', query: { to_top: 'true' } }">
              <img
                src="/static/renew3_img/yagiprime_img/logo.svg"
                alt="yagishブラウザでつくる履歴書・職務経歴書"
              />
            </router-link>
          </h1>

          <h1 v-else class="h1 flex">
            <router-link :to="{ path: '/', query: { to_top: 'true' } }">
              <img
                src="/static/renew2_img/yagish_logo_20230522.png"
                alt="yagishブラウザでつくる履歴書・職務経歴書"
              />
            </router-link>
          </h1>
        </div>

        <!--ヘッダー右-->
        <div class="header-right">
          <!--ヘッダー上段-->
          <ul class="renew2_flex sub_menu renew2_pc">
            <!--<li class="menu_list renew2_link_toggle" v-if="true"><a href="https://www.youtube.com/@yagish-df1zb"
                target="_blank">公式YouTube</a></li>
            <li class="menu_list renew2_link_toggle" v-if="true"><a href="https://resume.yagish.net/"
                target="_blank">韓国語</a></li>-->
            <li class="menu_list renew2_link_toggle">
              <a href="/static/know-how/" target="_blank"
                >履歴書の書き方に迷ったら？</a
              >
            </li>
            <li class="menu_list renew2_link_toggle">
              <a href="https://www.yagish.jp/" target="_blank">運営会社</a>
            </li>
            <li class="menu_list contact renew2_link_toggle">
              <a href="/contact">お問い合わせ</a>
            </li>
          </ul>

          <!--ヘッダー下段-->
          <ul
            class="renew2_flex menu"
            v-if="$route.params.formatId != 'rirekisho_esf_challenged'"
          >
            <li v-if="isOemDisplayAllowed" class="renew2_pc menu_list">
              <a href="/format/rirekisho_job_change" class="menu-item"
                >履歴書</a
              >
            </li>
            <li v-if="isOemDisplayAllowed" class="renew2_pc menu_list">
              <a href="/static/arbeit_debut/" class="menu-item"
                >履歴書デビュー</a
              >
            </li>
            <li v-if="isOemDisplayAllowed" class="renew2_pc menu_list">
              <a href="/static/ocr/" class="menu-item">履歴書を読み取る</a>
            </li>
            <li v-if="isOemDisplayAllowed" class="renew2_pc menu_list">
              <a href="/format/shokumukeirekisho" class="menu-item"
                >職務経歴書</a
              >
            </li>
            <!--<li class="renew2_pc menu_list"><a href="/servicelist" class="menu-item">サービス一覧</a></li>-->

            <li v-if="!isOemDisplayAllowed" style="flex: 1"></li>

            <!--ログインしてない場合-->
            <!--ログインフォームが会員登録も兼ねるようになったため導線は1つに統合-->
            <li
              v-if="!$firebase.isAuthenticated"
              class="menu_list register-wrap"
            >
              <a href="/login" class="register">ログイン・会員登録</a>
            </li>

            <li v-else class="menu_list">
              <a
                v-if="
                  $firebase.isAuthenticated &&
                  (!$globalVar.isYagiPrime || $globalVar.isYagiPrimeCancel)
                "
                class="mypage-btn"
                href="/mypage"
                >マイページ</a
              >
              <a
                v-if="
                  $firebase.isAuthenticated &&
                  $globalVar.isYagiPrime &&
                  !$globalVar.isYagiPrimeCancel
                "
                class="mypage-btn"
                href="/mypage/yagiprime"
              >
                マイページ
                <span class="header-count">{{ csCount }}</span>
              </a>
            </li>

            <li class="renew2_sp menu_list hamburgermenu-wrap">
              <div class="hamburger-demo-menubox">
                <input
                  id="hamburger-demo1"
                  type="checkbox"
                  class="input-hidden"
                />
                <label
                  for="hamburger-demo1"
                  class="hamburger-demo-switch hamburger-demo-switch1"
                >
                  <span class="hamburger-switch-line1"></span>
                </label>
                <div class="hamburger-demo-menuwrap">
                  <div class="clear">
                    <!--マイカード-->
                    <div class="member_card" v-if="$firebase.isAuthenticated">
                      <div class="mc01">
                        <div class="left01">
                          <p
                            v-if="
                              !$globalVar.isYagiPrime &&
                              !$globalVar.isYagiPrimeCancel
                            "
                          >
                            会員：
                            <a
                              href="/yagiprime_register"
                              id="prime-mypagetop-btn"
                              class="status"
                            >
                              一般会員（アップグレード）
                            </a>
                          </p>
                          <p
                            v-else-if="
                              $globalVar.isYagiPrime &&
                              $globalVar.isYagiPrimeCancel
                            "
                          >
                            会員：
                            <a href="/mypage/yagiprime" class="status">
                              一般会員（ヤギプライム解約手続き済）
                            </a>
                          </p>
                          <p v-else>
                            会員：
                            <a href="/mypage/yagiprime" class="status">
                              ヤギプライム会員
                            </a>
                          </p>

                          <p class="name">
                            名前：
                            <span v-if="getName">{{ getName }} </span>
                            <span v-else>{{ $firebase.user.email }}</span>
                          </p>

                          <p class="yagidy" v-if="digramResult">
                            ヤギ：
                            <span>{{
                              digramResult.detail_value.catch_copy_title
                            }}</span>
                          </p>
                          <p class="yagidy" v-else>
                            ヤギ：
                            <a href="/yagidigram/">あなたのヤギは？</a>
                          </p>

                          <p class="u-mail">
                            <span>{{ $firebase.user.email }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="mc02">
                        <a href="/mypage" class="mp-link">マイページ</a>
                      </div>
                    </div>
                    <div class="member_card" style="height: auto" v-else>
                      <p style="text-align: center; font-weight: bold">
                        ＼無料で会員登録／
                      </p>
                      <div class="mc02">
                        <a href="/login" class="mp-link">ログイン・会員登録</a>
                      </div>
                    </div>

                    <!--サービスリンク-->
                    <div class="servicelink">
                      <div class="renew2_flex renew2_sp_flex servicelink-item">
                        <h4 class="sl-h4">つくる</h4>
                        <ul class="sl-list">
                          <li>
                            <a
                              href="/format/rirekisho_job_change"
                              class="sl-link"
                              >履歴書</a
                            >
                          </li>
                          <li>
                            <a href="/static/ocr/" class="sl-link"
                              >履歴書を読み取る(OCR)</a
                            >
                          </li>
                          <li>
                            <a href="/format/shokumukeirekisho" class="sl-link"
                              >職務経歴書</a
                            >
                          </li>
                          <li>
                            <a href="/format/letter" class="sl-link">送付状</a>
                          </li>
                        </ul>
                      </div>
                      <div class="renew2_flex renew2_sp_flex servicelink-item">
                        <h4 class="sl-h4">サービス</h4>
                        <ul class="sl-list">
                          <li>
                            <a href="/servicelist" class="sl-link"
                              >サービス一覧を見る</a
                            >
                          </li>

                          <li v-if="$firebase.isAuthenticated">
                            <a href="/mypage/yagioffer" class="sl-link"
                              >オファーを確認する</a
                            >
                          </li>
                          <li v-else>
                            <a
                              style="line-height: 1.4"
                              href="/format/rirekisho_job_change"
                              class="sl-link"
                              >オファーを受け取る<br />（履歴書作成）</a
                            >
                          </li>

                          <li v-if="$firebase.isAuthenticated">
                            <a href="/mypage/yagiprime" class="sl-link"
                              >AIを使ってみる</a
                            >
                          </li>
                          <li v-else>
                            <a href="/yagiprimeinfo" class="sl-link"
                              >ヤギプライム</a
                            >
                          </li>

                          <li>
                            <a href="/yagidigram" class="sl-link"
                              >ヤギディ診断する</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!--各種リンク-->
                    <div class="otherlink">
                      <ul class="renew2_sp_flex ol-item">
                        <li class="ol-list">
                          <a href="/help" target="_blank" class="ol-link"
                            >よくある質問</a
                          >
                        </li>
                        <li class="ol-list">
                          <a href="/info" target="_blank" class="ol-link"
                            >使いかた</a
                          >
                        </li>
                        <li class="ol-list">
                          <a href="/terms" target="_blank" class="ol-link"
                            >利用規約</a
                          >
                        </li>
                        <li class="ol-list">
                          <a
                            href="https://www.yagish.jp/privacy/"
                            target="_blank"
                            class="ol-link"
                            >個人情報保護方針</a
                          >
                        </li>
                        <li class="ol-list">
                          <a
                            href="https://www.yagish.jp/company/"
                            target="_blank"
                            class="ol-link"
                            >運営会社について</a
                          >
                        </li>
                        <li class="ol-list">
                          <a href="/contact" target="_blank" class="ol-link"
                            >お問い合わせ</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="hamburger-demo-cover"></div>
              </div>
            </li>

            <li
              style="display: none"
              class="renew2_sp menu_list hamburgermenu-wrap"
            >
              <!--ハンバーガーメニュー-->
              <div
                class="renew_hamburgermenu-container"
                v-if="$site.appFlag != 'b'"
              >
                <input type="checkbox" id="overlay-input" />
                <label for="overlay-input" id="overlay-button"
                  ><span></span
                ></label>

                <!--ハンバーガーメニュー内-->
                <div id="renew_hamburgermenu" class="renew_hamburgermenu">
                  <div class="clear">
                    <!--マイカード-->
                    <div class="member_card" v-if="$firebase.isAuthenticated">
                      <div class="renew2_flex renew2_sp_flex mc01">
                        <div class="member_card_left">
                          <div class="left01">
                            <p
                              v-if="
                                !$globalVar.isYagiPrime &&
                                !$globalVar.isYagiPrimeCancel
                              "
                            >
                              <a
                                href="/yagiprime_register"
                                id="prime-mypagetop-btn"
                                class="status"
                                >一般会員（ヤギプライム会員になる）</a
                              >
                            </p>
                            <p
                              v-else-if="
                                $globalVar.isYagiPrime &&
                                $globalVar.isYagiPrimeCancel
                              "
                            >
                              <a href="/mypage/yagiprime" class="status"
                                >一般会員（ヤギプライム解約手続き済）</a
                              >
                            </p>
                            <p v-else>
                              <a href="/mypage/yagiprime" class="status"
                                >ヤギプライム会員</a
                              >
                            </p>
                            <p class="name">
                              <span v-if="getName">{{ getName }} </span
                              ><span v-else>{{ $firebase.user.email }}</span>
                              さん
                            </p>
                            <p>
                              （ <span>{{ $firebase.user.email }}</span> ）
                            </p>
                          </div>
                          <!----><!---->
                        </div>
                        <div class="member_card_right yagi_info">
                          <div class="dialogEnabled messageEnabled">
                            <your-yagi
                              :your-yagi-class="{}"
                              :yagi-options="{
                                dialogEnabled: true,
                                rubyEnabled: false,
                                messageEnabled: true
                              }"
                            ></your-yagi>
                          </div>
                          <p class="your-yagi-title">あなたのヤギ</p>
                        </div>
                      </div>
                      <div class="mc02">
                        <a href="/mypage" class="mp-link">マイページ</a>
                      </div>
                    </div>
                    <div class="member_card" style="height: auto" v-else>
                      <p style="text-align: center; font-weight: bold">
                        ＼無料で会員登録／
                      </p>
                      <div class="mc02" style="">
                        <a href="/login" class="mp-link" style=""
                          >ログイン・会員登録</a
                        >
                      </div>
                    </div>
                    <!--サービスリンク-->
                    <div class="servicelink">
                      <div class="renew2_flex renew2_sp_flex servicelink-item">
                        <h4 class="sl-h4">つくる</h4>
                        <ul class="sl-list">
                          <li><a href="" class="sl-link">履歴書</a></li>
                          <li>
                            <a href="/format/shokumukeirekisho" class="sl-link"
                              >職務経歴書</a
                            >
                          </li>
                          <li>
                            <a href="/format/letter" class="sl-link">送付状</a>
                          </li>
                        </ul>
                      </div>
                      <div class="renew2_flex renew2_sp_flex servicelink-item">
                        <h4 class="sl-h4">サービス</h4>
                        <ul class="sl-list">
                          <li>
                            <a href="/yagiprimequickemail/info" class="sl-link"
                              >メール送信（ヤギのメール便）</a
                            >
                          </li>

                          <li v-if="$firebase.isAuthenticated">
                            <a href="/mypage/yagioffer" class="sl-link"
                              >ヤギオファーを確認する</a
                            >
                          </li>
                          <li v-else>
                            <a
                              href="/format/rirekisho_job_change"
                              class="sl-link"
                              >オファーを受け取る（履歴書作成）</a
                            >
                          </li>

                          <li v-if="$firebase.isAuthenticated">
                            <a href="/mypage/yagiprime" class="sl-link"
                              >ヤギプライム</a
                            >
                          </li>
                          <li v-else>
                            <a href="/yagiprimeinfo" class="sl-link"
                              >ヤギプライム</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!--各種リンク-->
                    <div class="otherlink">
                      <ul class="renew2_flex renew2_sp_flex ol-item ol-item01">
                        <li class="ol-list">
                          <a
                            href="/help"
                            target="_blank"
                            class="ol-link"
                            id="test"
                            >よくある質問</a
                          >
                        </li>
                        <li class="ol-list">
                          <a href="/info" target="_blank" class="ol-link"
                            >使いかた</a
                          >
                        </li>
                      </ul>
                      <ul class="renew2_flex renew2_sp_flex ol-item ol-item02">
                        <li class="ol-list">
                          <a href="/terms" target="_blank" class="ol-link"
                            >利用規約</a
                          >
                        </li>
                        <li class="ol-list">
                          <a
                            href="https://www.yagish.jp/privacy/"
                            target="_blank"
                            class="ol-link"
                            >個人情報保護方針</a
                          >
                        </li>
                        <li class="ol-list">
                          <a
                            href="https://www.yagish.jp/company/"
                            target="_blank"
                            class="ol-link"
                            >運営会社について</a
                          >
                        </li>
                        <li class="ol-list">
                          <a href="/contact" target="_blank" class="ol-link"
                            >お問い合わせ</a
                          >
                        </li>
                      </ul>
                    </div>

                    <p class="hm-copyright">
                      ©2021-2024 Yagish Co., Ltd. All rights reserved.
                    </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul class="renew2_flex menu" v-else>
            <li
              v-if="$firebase.isAuthenticated"
              class="menu_list renew2_mypage"
            >
              <a href="/mypage" class="on_mypage"
                ><span v-if="$firebase.user.displayName"
                  >{{ $firebase.user.displayName }} </span
                >[ {{ $firebase.user.email }} ]
                <div id="email_for_googleads" style="display: none">
                  {{ $firebase.user.email }}
                </div>
                <span class="renew2_font_small">さん</span></a
              >
            </li>
            <!--登録メールアドレス-->
          </ul>
        </div>
      </div>

      <!--Appleログインして、メアドが***@privaterelay.appとなった場合の警告-->
    </header>
    <private-relay-warning-dialog></private-relay-warning-dialog>
    <div class="applelogin-user-attention" v-if="isAppleRelayEmail">
      <p class="applelogin-user-attention__txt">
        ※ログインしているアカウントのメールアドレスは<span
          style="font-size: 120%"
          >{{ $firebase.user.email }}</span
        >です。<br />正常なサービスを利用するためにはメールアドレスの変更が必要です。
      </p>
      <a href="/mypage/basicinfo" class="applelogin-user-attention__btn"
        >メールアドレスの変更はこちら</a
      >
    </div>

    <div
      style="text-align: center"
      v-if="$firebase.isAuthenticated && $globalVar.in_app_payments && false"
    >
      <!-- <a href="/yagiprime_superagent" v-if="randomNumber == 0"
        style="background: #FFF6B4;display: block;color: #004D40;padding: 5px 0; ">ヤギプライムなら、<span
          style="font-weight: bold;">充実した就活支援！</span> ▷</a>
      <a href="/ai/interview_practice" v-else
        style="background: #FFF6B4;display: block;color: #004D40;padding: 5px 0; ">ヤギプライムなら、<span
          style="font-weight: bold;">AIと面接の練習ができる！</span> ▷</a> -->
      <a
        href="#"
        style="background: #fff6b4; display: block; color: red; padding: 5px 0"
        >※現在AI機能がメンテナンス中です。正常になるまで少々お待ちください。</a
      >
    </div>

    <router-view v-if="!isAptitudeRoute" />

    <div id="aptitude-body" v-else>
      <router-view />
    </div>

    <button
      type="button"
      class="el-button el-button--primary"
      @click="goBack"
      v-if="!isTopPage && $site.appFlag == 'b'"
      style="
        background: #fff;
        color: #e3165c;
        position: fixed;
        bottom: 30px;
        left: 10px;
        z-index: 90;
      "
    >
      <!----><!----><span><i class="el-icon-d-arrow-left"></i>もどる</span>
    </button>

    <footer
      id="renew2_footer"
      class="renew2_footer"
      v-if="
        $site.appFlag != 'b' &&
        !isOnlyPreview &&
        !$route.path.startsWith('/yagifriends')
      "
    >
      <div class="renew2_wrapper">
        <div class="flex footer_top">
          <a href="/" class="ft-link"
            ><img
              src="/static/renew2_img/logo.svg"
              alt="ヤギッシュ"
              class="ft-img"
          /></a>
          <p class="ft-lead">
            yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。
          </p>
        </div>

        <div class="footer_middle">
          <ul class="flex fm-btn-linklist">
            <li class="fm-btn-linkitem">
              <a href="/format/rirekisho_job_change" class="fm-btn-link">
                <img
                  src="/static/renew2_img/fm-btn-img01.png"
                  alt="履歴書を作る"
                  class="fm-btn-img"
                />
              </a>
            </li>
            <li class="fm-btn-linkitem">
              <a href="/info" class="fm-btn-link">
                <img
                  src="/static/renew2_img/fm-btn-img02.png"
                  alt="yagishの使いかた"
                  class="fm-btn-img"
                />
              </a>
            </li>
            <li class="fm-btn-linkitem">
              <a href="/help" class="fm-btn-link">
                <img
                  src="/static/renew2_img/fm-btn-img03.png"
                  alt="よくある質問"
                  class="fm-btn-img"
                />
              </a>
            </li>
          </ul>

          <!--<ul class="flex fm-linklist">
            <li class="fm-linkitem">
              <a href="/servicelist" class="fm-link">サービス一覧</a>
            </li>
            <li class="fm-linkitem">
              <a href="/price" class="fm-link">料金表</a>
            </li>
            <li class="fm-linkitem"></li>
          </ul>-->

          <ul class="flex fm-linklist">
            <li class="fm-linkitem">
              <a href="/format/rirekisho_job_change" class="fm-link"
                >履歴書作成</a
              >
            </li>
            <li class="fm-linkitem">
              <a href="/static/ocr/" class="fm-link">履歴書を読み取る(OCR)</a>
            </li>
            <li class="fm-linkitem">
              <a href="/static/know-how/" class="fm-link"
                >履歴書書き方完全ガイド</a
              >
            </li>
            <li class="fm-linkitem">
              <a href="/format/shokumukeirekisho" class="fm-link"
                >職務経歴書作成</a
              >
            </li>
            <li class="fm-linkitem">
              <a href="/format/letter" class="fm-link">送付状作成</a>
            </li>
            <!--<li class="fm-linkitem">
              <a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank"
                class="fm-link fm-link-tab">各大学専用履歴書</a>
            </li>
            <li class="fm-linkitem">
              <a href="/quickemailhelp" class="fm-link">ヤギのメール便（企業に送信）</a>
            </li>
            <li class="fm-linkitem">
              <a href="/fontservicehelp" class="fm-link">フォントサービス</a>
            </li>
            <li class="fm-linkitem">
              <a href="/yagiprimeinfo" class="fm-link">ヤギプライム</a>
            </li>
            <li class="fm-linkitem">
              <a href="/yagiprime_adlp_interview" class="fm-link">AI面接練習[お試し可]</a>
            </li>
            <li class="fm-linkitem">
              <a href="/ai/aptitude_practice" class="fm-link">AI適性検査[お試し可]</a>
            </li>
            <li class="fm-linkitem">
              <a href="/ai/self_analysis" class="fm-link">AI自己分析[お試し可]</a>
            </li>
            <li class="fm-linkitem">
              <a href="https://www.yagish.jp/business/yagibot/" target="_blank"
                class="fm-link fm-link-tab">yagibot（LINEで履歴書作成）</a>
            </li>
            <li class="fm-linkitem">
              <a href="https://www.yagish.jp/business/yagitime/" target="_blank"
                class="fm-link fm-link-tab">大学生スケジュールアプリ</a>
            </li>
            <li class="fm-linkitem">
              <a href="/yagidigram" class="fm-link">ヤギディ(性格)診断</a>
            </li>
            <li class="fm-linkitem">
              <a href="https://www.youtube.com/@yagish-df1zb" target="_blank" class="fm-link fm-link-tab">公式YouTube</a>
            </li>
            <li class="fm-linkitem" v-if="getMode != 'productionX'">
              <a href="https://resume.yagish.net/" target="_blank" class="fm-link fm-link-tab">韓国版履歴書サイト</a>
            </li>-->
            <li class="fm-linkitem"></li>
          </ul>
        </div>

        <div v-if="$firebase.isAuthenticated" class="flex footer_middle02">
          <a
            href="https://store.line.me/stickershop/author/4427017/ja"
            class="fm02-link"
            target="_blank"
          >
            <img
              src="/static/mypage/linestampbnr.png"
              alt="LINEスタンプ"
              class="fm02-linkimg"
            />
          </a>
          <a href="/yagiprimeinfo" class="fm02-link">
            <img
              src="/static/mypage/primebnr.png"
              alt="ヤギプライム"
              class="fm02-linkimg"
            />
          </a>
          <a href="/yagidigram" class="fm02-link">
            <img
              src="/static/mypage/digrambnr.png"
              alt="ヤギディ診断"
              class="fm02-linkimg"
            />
          </a>
          <a
            href="https://www.youtube.com/@yagish-df1zb"
            class="fm02-link"
            target="_blank"
          >
            <img
              src="/static/mypage/youtubebnr.png"
              alt="公式youtube"
              class="fm02-linkimg"
            />
          </a>
          <a href="/quickemailhelp" class="fm02-link" target="_blank">
            <img
              src="/static/mypage/mail-banner.png"
              alt="メール便"
              class="fm02-linkimg"
            />
          </a>
          <a href="https://privacymark.jp/" class="fm02-link" target="_blank">
            <img
              src="/static/mypage/pmarkbnr.png"
              alt="Pマーク"
              class="fm02-linkimg"
            />
          </a>
          <a
            tabindex="-1"
            class="fm02-link"
            target="_blank"
            style="margin-bottom: 0"
          ></a>
        </div>

        <div class="footer_bottom">
          <ul class="flex fb-linklist">
            <li class="fb-linkitem">
              <a href="https://www.yagish.jp/" target="_blank" class="fb-link"
                >運営会社</a
              >
            </li>
            <li class="fb-linkitem">
              <a
                href="https://www.yagish.jp/privacy/"
                target="_blank"
                class="fb-link"
                >個人情報保護方針</a
              >
            </li>
            <li class="fb-linkitem">
              <a
                href="https://www.yagish.jp/privacy_policy/"
                target="_blank"
                class="fb-link"
                >プライバシーポリシー</a
              >
            </li>
            <li class="fb-linkitem">
              <a href="/law" class="fb-link">特定商取引法に基づく表示</a>
            </li>
            <li class="fb-linkitem">
              <a href="/terms" class="fb-link">利用規約</a>
            </li>
          </ul>

          <ul class="flex fb-linklist">
            <li class="fb-linkitem">
              <a
                href="https://www.yagish.jp/recruit/"
                target="_blank"
                class="fb-link"
                >採用情報</a
              >
            </li>
            <li class="fb-linkitem">
              <a href="/contact" class="fb-link">お問い合わせ</a>
            </li>
          </ul>
        </div>

        <div
          v-if="getMode != 'production'"
          class="renew2_flex renew2_sp_flex"
          style="justify-content: center; margin-top: 10px"
        >
          <el-button
            type="success"
            style="background-color: #0f9934; border-color: #0f9934"
            @click="invokeNative"
            >iOS送信しました{{ eventvalue }}</el-button
          >
          <el-button
            type="success"
            style="background-color: #0f9934; border-color: #0f9934"
            @click="$globalVar.invokeNative('pdf_android_rt_completed')"
            >Android送信しました</el-button
          >
        </div>

        <p class="copyright">
          ©2021-<span v-text="new Date().getFullYear()"></span> Yagish Co., Ltd.
          All rights reserved.
        </p>
      </div>
    </footer>

    <account-dialog />
    <introduction-dialog />
    <all-preview-dialog />
    <yagioffer-dialog />
    <joblist-dialog />
    <loginform-dialog />
    <fontpayment-dialog />
    <yagiprimefontpayment-dialog />
    <!--<carat-dialog />-->
    <workgate-popup-dialog />
    <yagioffer-special-dialog />
    <notice-dialog />
    <ai-reason-bnr />
    <prime-complete-popup />
    <skill-diagnosis-popup />
    <!-- 広告同意モーダルはブラウザ専用。アプリWebView(appFlag='b')では表示しない
         （MAID/アプリ内Metaの同意はネイティブ側でATT含め扱うため） -->
    <ad-consent-modal v-if="$site.appFlag != 'b'" />

    <div v-if="yfPageLoading" class="yf-page-loader">
      <div class="yf-page-loader__inner">
        <img
          src="/static/img/yagifriends/yagifriendslogo.png"
          alt="YagiFriends"
          class="yf-page-loader__logo"
        />
        <div class="yf-page-loader__dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<style lang="css" src="@/assets/css/renew2_style.css"></style>
<!--<style lang="css" src="@/assets/css/renew2_login.css"></style>-->

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

#renew2_header .renew2_mypage {
  margin-right: 50px;
}

/* hamburgerここから */
/* inputを非表示 */
.input-hidden {
  display: none;
}

/* label */
.hamburger-demo-switch {
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 0;
  z-index: 3;
  width: 35px;
  height: 35px;
}

/* メニュー展開時にハンバーガーアイコンを固定 */
#hamburger-demo1:checked ~ .hamburger-demo-switch {
  position: fixed;
  top: 10px;
}

/* ハンバーガーアイコン */
.hamburger-switch-line1,
.hamburger-switch-line1:before,
.hamburger-switch-line1:after {
  width: 25px;
  height: 3px;
  background: #004d40;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transition: 0.3s;
  content: '';
}

.hamburger-switch-line1 {
  transform: translate(-50%, -50%);
}

.hamburger-switch-line1:before {
  transform: translate(-50%, -300%);
}

.hamburger-switch-line1:after {
  transform: translate(-50%, 200%);
}

/* ハンバーガーアイコン･アニメーション */
#hamburger-demo1:checked ~ .hamburger-demo-switch .hamburger-switch-line1 {
  width: 0;
}

#hamburger-demo1:checked
  ~ .hamburger-demo-switch
  .hamburger-switch-line1:before {
  transform: rotate(45deg) translate(-40%, 325%);
}

#hamburger-demo1:checked
  ~ .hamburger-demo-switch
  .hamburger-switch-line1:after {
  transform: rotate(-45deg) translate(-40%, -325%);
}

/* メニューエリア */
.hamburger-demo-menuwrap {
  position: fixed;
  height: 100%;
  background: #fafafa;
  /* メニューエリアの背景色 */
  padding: 3.5em 3% 2em;
  z-index: 2;
  transition: 0.3s;
  overflow-y: scroll;
  /* メニュー内容が多い場合に縦スクロールする */
  top: 0;
  left: 100%;
  width: 90%;

  .clear {
    .member_card {
      background: #8fbd67;
      color: #fff;
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 20px;

      .mc01 {
        align-items: center;

        .left01 {
          margin-bottom: 15px;
          color: #fff;
          font-weight: bold;
          font-size: 14px;

          .status {
            color: #fff;
          }
        }
      }
    }

    .servicelink {
      margin-bottom: 20px;

      .servicelink-item {
        justify-content: space-between;
        padding: 20px;
        border-bottom: 1px solid #dfdfdf;

        &:first-child {
          padding: 0 20px 20px;
        }

        .sl-h4 {
          color: #0f9934;
          font-size: 14px;
          line-height: 2.2;
        }

        .sl-list {
          width: calc(100% - 80px);
          line-height: 2.2;

          .sl-link {
            position: relative;
            display: block;
            width: 100%;

            &::after {
              content: '';
              width: 7px;
              height: 7px;
              border: 0;
              border-bottom: 2px solid #0f9934;
              border-right: 2px solid #0f9934;
              -webkit-transform: rotate(-45deg);
              transform: rotate(-45deg);
              position: absolute;
              top: 0;
              right: 15px;
              bottom: 0;
              margin: auto;
            }
          }
        }
      }
    }

    .otherlink {
      .ol-item {
        flex-wrap: wrap;

        .ol-list {
          width: calc(50% - 10px);
          font-size: 12px;
          margin: 4px;
        }
      }
    }

    .mp-link {
      position: relative;
      display: block;
      width: 100%;
      text-align: center;
      padding: 5px 0;
      font-weight: bold;
      color: #fff;
      font-size: 14px;
      background: #0f9934;
      border-radius: 10px;

      &::after {
        content: '';
        width: 7px;
        height: 7px;
        border: 0;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        position: absolute;
        top: 0;
        right: 15px;
        bottom: 0;
        margin: auto;
      }

      &:hover {
        opacity: 1;
        text-decoration: none;
      }
    }
  }
}

/* メニューエリア･アニメーション */
/* 右から */
#hamburger-demo1:checked ~ .hamburger-demo-menuwrap {
  left: 10%;
}

/* コンテンツカバー */
#hamburger-demo1:checked ~ .hamburger-demo-cover {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: rgba(3, 3, 3, 0.5);
  display: block;
}

//200万人キャンペーン
.user200 {
  text-align: center;
  //background: #FFF620;
  margin-bottom: 10px;
  height: 40px;
  line-height: 40px;
  background: url(/static/renew2_img/bnr/200bnr_back.png);
  background-size: contain;

  &__link {
    display: block;
    width: 100%;

    .user200-img {
      height: 40px;
      width: auto;
    }
  }
}

.yf-page-loader {
  position: fixed;
  inset: 0;
  background: #c2f2c8;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.yf-page-loader__inner {
  text-align: center;
}

.yf-page-loader__logo {
  height: 36px;
  width: auto;
  display: block;
  margin: 0 auto 20px;
}

.yf-page-loader__dots {
  display: flex;
  gap: 8px;
  justify-content: center;

  span {
    width: 8px;
    height: 8px;
    background: #0f9934;
    border-radius: 50%;
    animation: yf-dot-bounce 1.4s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes yf-dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.applelogin-user-attention {
  margin: 20px;
  padding: 20px;
  background: #ffcccc;
  border-radius: 10px;
  color: #e3165c;
  font-weight: bold;
  text-align: center;

  &__txt {
    margin-bottom: 8px;
    overflow-wrap: anywhere;

    @include max-width(sm) {
      text-align: left;
    }
  }

  &__btn {
    background: #fff;
    border: 1px solid #fff;
    padding: 7px 15px;
    border-radius: 20px;
    font-size: 12px;

    &:hover {
      opacity: 1;
      text-decoration: none;
      border: 1px solid #e3165c;
      background: #e3165c;
      color: #fff;
    }
  }
}
</style>

<script>
import AccountDialog from '@/components/AccountDialog'
import IntroductionDialog from '@/components/IntroductionDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import YagiOfferDialog from '@/components/YagiOfferDialog'
import JoblistDialog from '@/components/JobListDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
import YagiprimeFontPaymentDialog from '@/components/YagiprimeFontPaymentDialog'
import FontPaymentDialog from '@/components/FontPaymentDialog'
// import CaratDialog from '@/components/CaratDialog20240801'
import WorkgateDialog from '@/components/WorkgateDialog'
import YagiofferSpecialDialog from '@/components/YagiofferSpecialDialog'
import NoticeDialog from '@/components/NoticeDialog'
import AiReasonBnr from '@/components/AiReasonBnr'
import PrimeCompletePopup from '@/components/PrimeCompletePopup'
import PrivateRelayWarningDialog from '@/components/PrivateRelayWarningDialog'
import SkillDiagnosisPopup from '@/components/SkillDiagnosisPopup'
import AdConsentModal from '@/components/AdConsentModal'

export default {
  props: {
    isLight: {
      type: Boolean
    }
  },
  components: {
    'account-dialog': AccountDialog,
    'introduction-dialog': IntroductionDialog,
    'all-preview-dialog': AllPreviewDialog,
    'yagioffer-dialog': YagiOfferDialog,
    'joblist-dialog': JoblistDialog,
    'loginform-dialog': LoginFormDialog,
    'fontpayment-dialog': FontPaymentDialog,
    'yagiprimefontpayment-dialog': YagiprimeFontPaymentDialog,
    // 'carat-dialog': CaratDialog,
    'workgate-popup-dialog': WorkgateDialog,
    'yagioffer-special-dialog': YagiofferSpecialDialog,
    'notice-dialog': NoticeDialog,
    'ai-reason-bnr': AiReasonBnr,
    'prime-complete-popup': PrimeCompletePopup,
    'private-relay-warning-dialog': PrivateRelayWarningDialog,
    'skill-diagnosis-popup': SkillDiagnosisPopup,
    'ad-consent-modal': AdConsentModal
  },
  data: function () {
    return {
      headerTitle: 0,
      csCount: 0,
      randomNumber: 0,
      isYagiFriendsNavigating: false,
      yfInitialLoading: window.location.pathname.startsWith('/yagifriends'),
      eventvalue: ''
    }
  },
  methods: {
    invokeNative() {
      // MessageInvoker.postMessage('Trigger from Javascript code');
      // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // }).then(() => {
      // }).catch(() => {
      // })
    },
    // fromApp(data) {
    //   console.log(data)
    //   alert(data)
    // },
    goBack() {
      window.history.back()
    },
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    },
    authStateChanged: async function () {
      // 非ログイン時は処理をスキップ
      if (!this.$firebase || !this.$firebase.user) {
        return
      }
      console.error(this.$firebase.user.uid)
      const app = this
      this.$axios
        .get(
          this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/',
          null,
          { timeout: 60000 }
        )
        .then(function (response) {
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          app.$globalVar.subscription_type = response.data.subscription_type
          app.$globalVar.isYagiPrimeCancel = response.data.is_cancel
          if (response.data.is_subscribed) {
            const formData = new FormData()
            formData.append('uuid', app.$firebase.user.uid)

            app.$axios
              .post(app.$varuna.endPoints.subscriptionsMypage, formData, {
                timeout: 60000
              })
              .then(function (response) {
                console.error(response.data)
                const _joblist = response.data.recommended_jobs

                for (const _key in _joblist) {
                  const _job = _joblist[_key]
                  if (!_job.read_date) {
                    app.csCount++
                  }
                }
              })
              .catch(function (error) {
                console.error(error)
              })
              .finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function (error) {
          console.error(error)
        })
      if (
        app.$globalVar.deviceToken &&
        app.$globalVar.deviceToken.trim() !== ''
      ) {
        const subformData = new FormData()
        subformData.append('uuid', app.$firebase.user.uid)
        subformData.append('device_token', app.$globalVar.deviceToken)

        app.$axios
          .post(app.$varuna.endPoints.updateDeviceToken, subformData, {
            timeout: 60000
          })
          .then(function (response) {
            // app.$message({
            //   message: app.$globalVar.deviceToken + 'を更新完了',
            //   type: 'warning'
            // })
            console.error(response.data)
          })
          .catch(function (error) {
            console.error(error)
          })
      }
    }
  },
  computed: {
    yfPageLoading() {
      return this.yfInitialLoading || this.isYagiFriendsNavigating
    },
    isAppleRelayEmail() {
      try {
        if (
          this.$firebase &&
          this.$firebase.user &&
          this.$firebase.user.email &&
          this.$firebase.user.email.indexOf('@privaterelay.appleid.com') !== -1
        ) {
          return true
        }
      } catch (e) {
        console.error('Appleメール判定中にエラー:', e)
      }
      return false
    },
    getName: function () {
      if (this.$firebase.user && this.$firebase.user.displayName) {
        return this.$firebase.user.displayName
      } else {
        if (this.$firebase.user && this.$firebase.user.email) {
          return this.$firebase.user.email.split('@')[0]
        } else {
          return 'ヤギ'
        }
      }
    },
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    isAptitudeRoute() {
      return this.$route.path.startsWith('/aptitude')
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return this.$route.name === 'top'
    },
    isOnlyPreview: function () {
      return (
        this.$route.name === 'previewOnly' || this.$route.query.noheader === '1'
      )
    },
    isMynabi: function () {
      this.checkMynabi()
      return this.$yagi.isFromMynabi === 1
    },
    isEditingFormat: function () {
      return this.$route.name === 'formatEditCard'
    },
    needsFullScreen: function () {
      return this.$route.name === 'formatPreview'
    },
    needsFooter: function () {
      if (
        this.$route.name === 'formatPreview' ||
        this.$route.name === 'formatEditCard'
      ) {
        return false
      }
      return true
    },
    // OEMでの表示制御
    isOemDisplayAllowed() {
      if (
        this.$oemContext &&
        typeof this.$oemContext.isOemSite === 'function'
      ) {
        return !this.$oemContext.isOemSite()
      }
      return true
    }
  },
  created: function () {
    const app = this
    this.$watch(
      '$route',
      (route) => {
        if (route.query.evnt) {
          app.eventvalue = route.query.evnt
          app.$cookies.config(60 * 60 * 72, '')
          app.$cookies.set('_YAGISHAPP_FROM_NOTIFICATION', app.eventvalue)

          try {
            MessageInvoker.postMessage(app.eventvalue)
          } catch (error) {
            console.warn(
              `Error occurred while calling postMessage: ${error.message}`
            )
          }
          if (app.eventvalue === 'idphoto202605') {
            window.location.href = '/static/idphoto-mobile/'
          } else if (app.eventvalue === 'yagidia20260612') {
            window.location.href =
              'https://portal.yagish.jp/know-how/resume-reason/?frm=yagidia20260612'
          }
        }
      },
      { immediate: true }
    )
    // alert('alertテスト')
    window.saveToken = (uuid, detoken) => {
      const subformData = new FormData()
      subformData.append('uuid', uuid)
      subformData.append('device_token', detoken)

      app.$axios
        .post(app.$varuna.endPoints.updateDeviceToken, subformData, {
          timeout: 60000
        })
        .then(function (response) {
          // app.$message({
          //   message: app.$globalVar.deviceToken + 'を更新完了',
          //   type: 'warning'
          // })
          console.error(response.data)
        })
        .catch(function (error) {})
        .finally(function () {})
    }

    // Flutter からのメッセージを受信するために、window にメソッドを定義
    window.fromApp = (detoken) => {
      app.$globalVar.deviceToken = detoken
      if (app.$firebase.isAuthenticated) {
        if (
          app.$globalVar.deviceToken &&
          app.$globalVar.deviceToken.trim() !== ''
        ) {
          const subformData = new FormData()
          subformData.append('uuid', app.$firebase.user.uid)
          subformData.append('device_token', app.$globalVar.deviceToken)

          app.$axios
            .post(app.$varuna.endPoints.updateDeviceToken, subformData, {
              timeout: 60000
            })
            .then(function (response) {
              // app.$message({
              //   message: app.$globalVar.deviceToken + 'を更新完了',
              //   type: 'warning'
              // })
              console.error(response.data)
            })
            .catch(function (error) {})
            .finally(function () {})
        }
      }

      // app.$message({
      //   message: app.$globalVar.deviceToken + 'をセット完了',
      //   type: 'warning'
      // })
      // console.log("Flutterから受信:", message);
      // alert(message)
    }

    // Flutter からのメッセージを受信するために、window にメソッドを定義
    window.fromApp4Android = (detoken) => {
      app.$globalVar.deviceToken = detoken
      if (app.$firebase.isAuthenticated) {
        if (
          app.$globalVar.deviceToken &&
          app.$globalVar.deviceToken.trim() !== ''
        ) {
          const subformData = new FormData()
          subformData.append('uuid', app.$firebase.user.uid)
          subformData.append('device_token', app.$globalVar.deviceToken)

          app.$axios
            .post(app.$varuna.endPoints.updateDeviceToken, subformData, {
              timeout: 60000
            })
            .then(function (response) {
              // app.$message({
              //   message: app.$globalVar.deviceToken + 'を更新完了',
              //   type: 'warning'
              // })
              console.error(response.data)
            })
            .catch(function (error) {
              console.error(error)
            })
        }
      }

      // app.$message({
      //   message: app.$globalVar.deviceToken + 'をセット完了',
      //   type: 'warning'
      // })
      // console.log("Flutterから受信:", message);
      // alert(message)
    }

    console.error(this.$route.fullPath)
    console.error(this.$route.params.formatId)
    const nowdate = new Date()
    const dayOfWeek = nowdate.getDay()
    this.headerTitle = nowdate.getDate() % 4
    this.headerTitle = 99

    const formData = new FormData()
    formData.append('app_flag', this.$site.appFlag)
    this.$axios
      .post(this.$varuna.endPoints.siteSetting, formData, { timeout: 60000 })
      .then(function (response) {
        if (response.data.in_app_payments == 0) {
          app.$globalVar.in_app_payments = false
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  },
  beforeMount: function () {
    if (Math.floor(Math.random() * 2) == 0) {
      this.randomNumber = 0
    } else {
      this.randomNumber = 1
    }
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)

    this.$router.beforeEach((to, from, next) => {
      if (
        to.path.startsWith('/yagifriends') ||
        from.path.startsWith('/yagifriends')
      ) {
        this.isYagiFriendsNavigating = true
      }
      next()
    })
    this.$router.afterEach(() => {
      this.$nextTick(() => {
        this.isYagiFriendsNavigating = false
        this.yfInitialLoading = false
      })
    })
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
